export const removeDuplicatesByProperty = (arr, property) => {
  const seenValues = {};
  const result = [];

  arr.forEach((obj) => {
    if (property in obj) {
      const propValue = obj[property];
      if (!seenValues[propValue]) {
        seenValues[propValue] = true;
        result.push(obj);
      }
    }
  });

  return result;
};
